<div class="text-center ready-set-container">
	<h2 class="ready-set-header">About our Security</h2>
	<p class="mt-4 ready-set-content">
		Depend on a trustworthy environment to protect your sensitive compliance
		data <br class="d-none d-xxl-block" />
		with our enterprise-class cyber security.
	</p>
	<div class="about-security-bottom">
		<img width="100%" src="../../assets/img/about-security.svg" alt="" />
		<h2 class="compliance-header text-center">
			75% of government agency cybersecurity
			<br class="d-none d-xxl-block" />
			programs are "at-risk" or "high risk" with
			<br class="d-none d-xxl-block" />
			significant security gaps and a lack of
			<br class="d-none d-xxl-block" />
			fundamental processes.
		</h2>
	</div>
</div>
